module.exports = __webpack_public_path__ + "media/images/bsmart_logo-3853d51c8d754b19027a06e158abf697.png";